/**
 * The placeholder shown where a numeric card has no usable value.
 */
export const NO_NUMERIC_VALUE = "—";

/**
 * Coerces a raw custom-field value into something a numeric card can display.
 *
 * `Number()` returns `NaN` for anything non-numeric — never `null` or
 * `undefined` — so a `?? 0` beside it reads as a fallback without ever being
 * one. Absent and non-numeric values reached the cards as `NaN` (and, wherever
 * `formatNumber` was involved, as the string `"NaN"`).
 *
 * `null` and `""` are screened out before the coercion because `Number(null)`
 * and `Number("")` are both `0`, which would render an absent field
 * indistinguishably from one whose value really is zero.
 */
export function toDisplayNumber(value: unknown): number | string {
  if (value === null || value === undefined || value === "") {
    return NO_NUMERIC_VALUE;
  }

  const parsed = Number(value);
  return Number.isNaN(parsed) ? NO_NUMERIC_VALUE : parsed;
}
